import * as React from 'react';
import { useContext } from 'react';

import type { ProgramType } from 'bundles/audit/constants';
import type { SpecializationPricesResult } from 'bundles/audit/hooks/useMixAndMatchSpecializationPrices';

export type ProductPrice = { currencyCode: string; amount: number };

export type AuditUpgradeFlowDataContextType = {
  isFreemiumLearner: boolean;
  handleStartFreeTrialClick: () => void;
  productPrice?: ProductPrice;
  programType: ProgramType;
  programName: string;
  hasCompletedCourse?: boolean;
  hasCompletedFirstModule?: boolean;
  loadingHasCompletedFirstModule?: boolean;
  hasS12nFreeTrial?: boolean;
  courseId: string;
  mixAndMatchS12nIds?: string[];
  refetchHasCompletedFirstModule?: () => void;
  selectedS12nId?: string;
  setSelectedS12nId?: (s12nId?: string) => void;
  isEligibleForS12nPrepaid?: boolean;
  mixAndMatchSpecializationPrices?: SpecializationPricesResult;
};

/**
 * @todo remove the export, and migrate the current usage which import this to use useAuditUpgradeFlowData instead
 */
export const AuditUpgradeFlowDataContext = React.createContext<AuditUpgradeFlowDataContextType | null>(null);

/** Custom hook to use the AuditUpgradeFlowDataContext */
export const useAuditUpgradeFlowData = () => useContext(AuditUpgradeFlowDataContext);
